import { render, staticRenderFns } from "./extractDialog.vue?vue&type=template&id=257de86f&scoped=true"
import script from "./extractDialog.vue?vue&type=script&lang=js"
export * from "./extractDialog.vue?vue&type=script&lang=js"
import style0 from "./extractDialog.vue?vue&type=style&index=0&id=257de86f&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257de86f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-servicesplatform-fe/treasurenet-tnservices-servicesplatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('257de86f')) {
      api.createRecord('257de86f', component.options)
    } else {
      api.reload('257de86f', component.options)
    }
    module.hot.accept("./extractDialog.vue?vue&type=template&id=257de86f&scoped=true", function () {
      api.rerender('257de86f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/governance/proposal/extractDialog.vue"
export default component.exports